import * as React from 'react';
import { ClientScoreResultsTileComponent } from 'components/Dashboard/ClientScoreResultsTile';
import { connect } from 'react-redux';
import { fetchScoreResultsIfNeeded } from 'actions/scoreResults';
import { getOptionsIfNeeded } from '@pec/aion-ui-core/actions/options';
import { I18nextProps } from '@pec/aion-ui-i18next/types/i18n';
import { RootActions } from 'combineActions';
import { RootState } from 'combineReducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { ThunkDispatch } from 'redux-thunk';
import { Tile } from 'components/Tile';
import { toggleClientScoresTileExpandedOrganizationId } from 'actions/options';
import { withTranslation } from 'react-i18next';
import { fetchClientsForScores } from 'slices/clientsForScores';

type RouteParams = {
  organizationId: string;
};

const mapStateToProps = ({
  scoreResults: { scoreResults, error: scoresError, isFetching: isFetchingScoreResults },
  clientsForScores: { clientsForScores, error: clientsError, isFetching: isFetchingClients },
  options: { clientScoresTileExpandedOrganizationIds }
}: RootState) => ({
  scoreResults:
    scoreResults !== null &&
    scoreResults &&
    scoreResults.map(r => ({
      isExpanded: clientScoresTileExpandedOrganizationIds.indexOf(r.clientId) > -1,
      ...r
    })),
  clientsForScores,
  error: scoresError || clientsError,
  isFetching: isFetchingScoreResults || isFetchingClients,
  clientScoresTileExpandedOrganizationIds
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, null, RootActions>,
  {
    match: {
      params: { organizationId }
    }
  }: RouteComponentProps<RouteParams>
) => ({
  fetchScoreResultsIfNeeded: () => dispatch(fetchScoreResultsIfNeeded(organizationId)),
  getOptionsIfNeeded: () => dispatch(getOptionsIfNeeded()),
  getClients: () => dispatch(fetchClientsForScores(organizationId)),
  handleAccordionTitleClick: (organizationId: string) => () =>
    dispatch(toggleClientScoresTileExpandedOrganizationId(organizationId))
});

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<RouteParams> &
  I18nextProps;

class ClientScoreResultsTile extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchScoreResultsIfNeeded();
    props.getOptionsIfNeeded();
    props.getClients();
  }

  render() {
    const { scoreResults, clientsForScores, error, isFetching, t } = this.props;

    return scoreResults && !isFetching && !error ? (
      <ClientScoreResultsTileComponent
        scoreResults={scoreResults}
        clientsForScores={clientsForScores}
        handleClick={this.props.handleAccordionTitleClick}
      />
    ) : (
      <Tile
        isLoading={isFetching}
        hasError={!!error}
        primaryText={t('subscriber:dashboard.clientScoresTile.title', 'Client Scores')}
      />
    );
  }
}

export const ClientScoreResultsTileContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientScoreResultsTile))
);
